var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageTemplate',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 "},[_c('h1',[_vm._v("Terms and Conditions")])]),_c('div',{staticClass:"col-md-12 ",domProps:{"innerHTML":_vm._s(_vm.termsAndConditions)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }